import React from 'react'
import { View, Text, Image } from '@react-pdf/renderer'
import { PropTypes } from 'prop-types'

const Header = ({ mainColor, reportHeaderDataUrl }) => {
  const header = {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    flexDirection: 'row',
    padding: '10pt',
    color: 'white',
    width: '100%',
    marginBottom: 10,
    height: 50
  }
  const title = {
    fontSize: 16,

    alignSelf: 'center',
    fontFamily: 'Roboto',
    fontWeight: 'bold'
  }

  const numbers = {
    fontSize: 10,
    alignSelf: 'center',
    width: 150,

    textAlign: 'right'
  }
  return (
    <View
      style={[header, { backgroundColor: mainColor }]}
      debug={false}
      fixed={true}
    >
      <View
        style={{
          height: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignContent: 'center',
          flexDirection: 'row',
          width: 200,
          gap: 2
        }}
      >
        {reportHeaderDataUrl && (
          <Image
            src={reportHeaderDataUrl}
            style={{
              width: 40,
              height: 40,
              objectFit: 'cover',
              alignSelf: 'center'
            }}
          />
        )}
        <Text style={([title], { fontSize: 22 })}>Multimodal Tool</Text>
      </View>

      <Text style={[title]} debug={false}>
        Scoring Summary
      </Text>
      <Text
        style={[numbers]}
        debug={false}
        render={({ pageNumber }) => `Page ${pageNumber}`}
        fixed={true}
      />
    </View>
  )
}

export default Header

Header.propTypes = {
  mainColor: PropTypes.string.isRequired,
  reportHeaderDataUrl: PropTypes.string
}
